import CheckIcon from '../../icons/check';
import Sheet from '../sheet/sheet';

import './styles/picker-sheet.css';

// Bottom-sheet single choice, the pattern mobile apps use instead of a
// native <select>: one tap opens it, one tap picks and closes.
export default function PickerSheet({ isOpen, title, description, options, value, onSelect, onClose }) {
    const handlePick = (optionValue) => {
        onSelect(optionValue);
        onClose();
    };

    return (
        <Sheet isOpen={isOpen} title={title} description={description} onClose={onClose}>
            <div className="picker-sheet" role="radiogroup" aria-label={title}>
                {options.map((option) => {
                    const isSelected = String(option.value ?? '') === String(value ?? '');
                    return (
                        <button
                            key={option.value || 'all'}
                            type="button"
                            role="radio"
                            aria-checked={isSelected}
                            className={`picker-sheet__option${isSelected ? ' picker-sheet__option--selected' : ''}`}
                            onClick={() => handlePick(option.value)}
                        >
                            {option.icon && <span className="picker-sheet__icon">{option.icon}</span>}
                            <span className="picker-sheet__text">
                                <span className="picker-sheet__label">{option.label}</span>
                                {option.description && <span className="picker-sheet__description">{option.description}</span>}
                            </span>
                            {isSelected && <CheckIcon size={20} className="picker-sheet__check" />}
                        </button>
                    );
                })}
            </div>
        </Sheet>
    );
}
